import { ContactsByRelationQuery, Contact } from 'capability-ng-resources';
import * as _4 from 'lodash4';

export class MyPeopleDetailViewController {
  private contact: Contact;
  private relationship: string;

  constructor(
    private ngContactsByRelationQuery: ContactsByRelationQuery,
    private $stateParams: ng.ui.IStateParamsService
  ) {
    this.contact = ngContactsByRelationQuery.getContactFromGroup($stateParams.relationship, $stateParams.contactId);
    this.relationship = this.contact.relationship;
  }
}



// WEBPACK FOOTER //
// ./app/lib/my_resources/views/my_people_detail/my_people_detail_controller.ts